import { ReactComponent as PhoneSvg } from '../assets/phone.svg';

const PhoneIcon = () => (
  <PhoneSvg />
);

export default PhoneIcon;
